// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect } from "react";

const enum fields {
    hubspotScriptRegion = "hubspotScriptRegion",
    hubspotScriptPortalId = "hubspotScriptPortalId",
    hubspotScriptFormId = "hubspotScriptFormId",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.hubspotScriptRegion]: string;
        [fields.hubspotScriptPortalId]: string;
        [fields.hubspotScriptFormId]: string;
    };
}

export interface HubspotFormStyles {
    hubspotFormStyles?: InjectableCss;
}

const hubspotFormStyles: HubspotFormStyles = {};

declare global {
    interface Window {
        hbspt: {
            forms: {
                create: any;
            };
        };
    }
}

const HubspotForm = ({ fields }: OwnProps) => {
    const { hubspotScriptRegion, hubspotScriptPortalId, hubspotScriptFormId } = fields;
    const styles = hubspotFormStyles;

    useEffect(() => {
        const script = document.createElement("script");
        const tracker = document.createElement("script");

        script.src = "https://js.hsforms.net/forms/v2.js";
        tracker.src = `//js.hs-scripts.com/${hubspotScriptPortalId}.js`;

        document.body.appendChild(tracker);
        document.body.appendChild(script);

        script.addEventListener("load", () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    region: hubspotScriptRegion,
                    portalId: hubspotScriptPortalId,
                    formId: hubspotScriptFormId,
                    target: "#hubspotForm",
                });
            }
        });
    }, []);

    return (
        <StyledWrapper {...styles.hubspotFormStyles}>
            <div id="hubspotForm"></div>
        </StyledWrapper>
    );
};

const hubspotForm: WidgetModule = {
    component: HubspotForm,
    definition: {
        displayName: "HubSpot Form",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.hubspotScriptRegion,
                editorTemplate: "TextField",
                displayName: "Region",
                defaultValue: "na1",
                fieldType: "Contextual",
            },
            {
                name: fields.hubspotScriptPortalId,
                editorTemplate: "TextField",
                displayName: "PortalId",
                defaultValue: "",
                fieldType: "Contextual",
            },
            {
                name: fields.hubspotScriptFormId,
                editorTemplate: "TextField",
                displayName: "FormId",
                defaultValue: "",
                fieldType: "Contextual",
            },
        ],
    },
};

export default hubspotForm;
